// extracted by mini-css-extract-plugin
export default {"input_range":"ImageCropper_input_range__mU-fx"};